import * as Blockly from 'blockly';

const CHEVRON_SIZE = 18;
const CHEVRON_PADDING = 2;

/**
 * Custom Blockly field that renders a clickable chevron (▼/▲) for toggling hidden fields.
 * Usage in JSON: { type: 'field_chevron', name: 'HIDDEN_TOGGLE', expanded: false }
 */
export class FieldChevron extends Blockly.Field<boolean> {
  static SERIALIZABLE = true;
  private foreignObject_: SVGForeignObjectElement | null = null;
  private iconElement_: HTMLElement | null = null;

  static override fromJson(options: Blockly.FieldConfig & { expanded?: boolean }): FieldChevron {
    return new FieldChevron(options.expanded ?? false);
  }

  constructor(expanded: boolean = false) {
    super(expanded);
    (this as any).CURSOR = 'pointer';
  }

  override initView(): void {
    this.createBorderRect_();
    this.createChevron_();
    this.updateSize_();
  }

  private createChevron_(): void {
    if (!this.fieldGroup_) return;

    const fo = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
    fo.setAttribute('width', `${CHEVRON_SIZE + CHEVRON_PADDING * 2}`);
    fo.setAttribute('height', `${CHEVRON_SIZE + CHEVRON_PADDING * 2}`);
    fo.setAttribute('y', '0');

    const wrapper = document.createElement('div');
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'center';
    wrapper.style.width = '100%';
    wrapper.style.height = '100%';
    wrapper.style.cursor = 'pointer';
    wrapper.style.userSelect = 'none';
    wrapper.title = 'Mehr Optionen';

    const icon = document.createElement('i');
    icon.className = this.getValue() ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line';
    icon.style.color = 'rgba(255,255,255,0.8)';
    icon.style.fontSize = `${CHEVRON_SIZE - 4}px`;
    icon.style.lineHeight = '1';
    icon.style.transition = 'transform 0.2s ease';

    wrapper.appendChild(icon);
    fo.appendChild(wrapper);
    this.fieldGroup_.appendChild(fo);

    this.foreignObject_ = fo;
    this.iconElement_ = icon;
  }

  protected override updateSize_(): void {
    const totalWidth = CHEVRON_SIZE + CHEVRON_PADDING * 2;
    const totalHeight = CHEVRON_SIZE + CHEVRON_PADDING * 2;

    this.size_ = new Blockly.utils.Size(totalWidth, totalHeight);

    if (this.borderRect_) {
      this.borderRect_.setAttribute('width', `${totalWidth}`);
      this.borderRect_.setAttribute('height', `${totalHeight}`);
      this.borderRect_.style.fill = 'transparent';
      this.borderRect_.style.stroke = 'none';
    }
  }

  /** Called when the user clicks the chevron — triggers the block's toggle function */
  override showEditor_(): void {
    const block = this.getSourceBlock();
    if (block && (block as any).toggleHiddenFields) {
      (block as any).toggleHiddenFields();
    }
  }

  /** Update the chevron direction based on expanded state */
  setExpanded(expanded: boolean): void {
    this.setValue(expanded);
    if (this.iconElement_) {
      this.iconElement_.className = expanded ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line';
    }
  }
}

// Registrierung als Custom Field
Blockly.fieldRegistry.register('field_chevron', FieldChevron as any);
